'use client';

import { useState } from 'react';
import { EditModal } from '@/components/ui/edit-modal';
import { BasicInfoBannerField } from '@/features/tournament-wizard/blocks';

interface EditBannerModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentBannerUrl: string | null;
  onSave: (newBannerUrl: string | null) => Promise<boolean>;
  isLoading: boolean;
}

export function EditBannerModal({
  isOpen,
  onClose,
  currentBannerUrl,
  onSave,
  isLoading,
}: EditBannerModalProps) {
  const [newBannerUrl, setNewBannerUrl] = useState<string | null>(
    currentBannerUrl,
  );
  const [isUploading, setIsUploading] = useState(false);

  const handleSave = async () => {
    await onSave(newBannerUrl);
  };

  return (
    <EditModal
      isOpen={isOpen}
      onClose={onClose}
      title="Editar Banner del Torneo"
      onSave={handleSave}
      isLoading={isLoading || isUploading}
    >
      <div className="grid gap-4 py-4">
        <BasicInfoBannerField
          bannerUrl={newBannerUrl}
          onBannerUrlChange={setNewBannerUrl}
          wrapInCard={false}
          altText="Previsualización del banner del torneo"
          onUploadingChange={setIsUploading}
        />
      </div>
    </EditModal>
  );
}
